import React from 'react';
import Icon from '../Icon/Icon';
import Card from '../Card/Card';

/**
 * Feature item with icon and description
 * Used in About section and other feature lists
 */
const FeatureItem = ({
  icon,
  title,
  description,
  className = '',
}) => {
  return (
    <Card 
      variant="default" 
      padding="md" 
      className={`flex items-center gap-4 ${className}`}
    >
      <div className="bg-primary/20 h-10 w-10 flex items-center justify-center rounded-lg text-primary shrink-0">
        <Icon name={icon} size="md" />
      </div>
      <div className="flex-1">
        <h4 className="text-white text-sm font-bold">{title}</h4>
        <p className="text-gray-500 text-xs mt-0.5">{description}</p>
      </div>
    </Card>
  );
};

export default FeatureItem;
